import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'products',
            name: 'product',
            class: 'Modules\\Product\\Entities\\Product',

            dataTable: {
                headerTopComponents: [
                    {
                        component: 'export-component',
                        bind: {
                            href: route('pages.admin.site.products.export'),
				            text: "Exportar Productos"
                        },
                        html: null,
                        on: {}
                    },
                    {
                        component: 'product-import-component',
                        bind: {},
                        html: null,
                        on: {}
                    }
                ],
                headerBottomComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ]
            }
        }
    },

    methods: {
        getFormattedMeasureUnit(value) {
            switch(value) {
                case 'MGM':
                    value = 'Miligramos'
                break
        
                case 'GRM':
                    value = 'Gramos'
                break
        
                case 'KGM':
                    value = 'Kilogramos'
                break
        
                case 'MLT':
                    value = 'Mililitros'
                break
        
                case 'LTR':
                    value = 'Litros'
                break
        
                case 'XPK':
                    value = 'Paquete'
                break
        
                case 'H87':
                    value = 'Unidad'
                break
            }
        
            return value
        },

        getFormattedType(value) {
            // switch(value) {
            //     //
            // }
        
            return value
        },



        

        addToCart(resource, quantity = 1, success = null) {
            if (this.$models.$applicant.postcode) {
                this.makeAdd(resource, quantity, success)

            } else {
                this.$models.$applicant.openPostcodesDialog(
                    () => this.makeAdd(resource, quantity, success)
                )
            }
        },

        makeAdd(resource, quantity = 1, success = null) {
            this.$cart.addItem({
                buyable_type: resource.buyable_data.buyable_type,
                buyable_id: resource.buyable_data.buyable_id,
                quantity: quantity,
            })
            .then(() => {
                if(success) {
                    success()
                }
            })
        }
    }
}